/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import i18n from 'i18next';

import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';

import { Button, ButtonGroup } from 'uikit/buttons';
import TextInput from 'uikit/inputs/components/textInput';

import CustomFilter from './customFilter';

import styles from '../styles/uikitManageManageSearch.module.scss';

const ManageSearch = ({
  className = '',
  customFilterProps = {},
  filtersCount = 0,
  hasCustomFilterButton = false,
  hasDisplayButton = false,
  hasFilterButton = false,
  hasSearch = true,
  inputId = 'search-input',
  isCustomFilterDisabled = false,
  isDisabled = false,
  isDisplayButtonDisabled = false,
  isFilterButtonDisabled = false,
  isSearchDisabled = false,
  onDisplayButtonClick = () => {},
  onFilterButtonClick = () => {},
  onSearchChange = () => {},
  onSearchClick = () => {},
  onSearchFocus = () => {},
  searchPlaceholder = i18n.t('search', 'Search'),
  searchValue = '',
}) => (
  <div className={classnames(styles.element, className)}>
    {(hasCustomFilterButton || hasFilterButton || hasDisplayButton) && (
      <ButtonGroup variant="compact">
        {hasCustomFilterButton && (
          <CustomFilter {...customFilterProps} isDisabled={isDisabled || isCustomFilterDisabled} />
        )}
        {hasFilterButton && (
          <Button
            icon={<FilterListOutlinedIcon />}
            isDisabled={isDisabled || isFilterButtonDisabled}
            isMetadataHighlighted
            metadata={filtersCount > 0 ? filtersCount : null}
            onClick={onFilterButtonClick}
            size="small"
            text={i18n.t('filter', 'Filter')}
            variant="ghost"
          />
        )}
        {hasDisplayButton && (
          <Button
            icon={<FilterListOutlinedIcon />}
            isDisabled={isDisabled || isDisplayButtonDisabled}
            onClick={onDisplayButtonClick}
            size="small"
            text={i18n.t('display', 'Display')}
            variant="ghost"
          />
        )}
      </ButtonGroup>
    )}
    {hasSearch && (
      <div className={styles.search}>
        <TextInput
          className={styles.searchInput}
          id={inputId}
          isDisabled={isDisabled || isSearchDisabled}
          onFocus={onSearchFocus}
          onChange={onSearchChange}
          onClick={onSearchClick}
          placeholder={searchPlaceholder}
          shouldShowCloseButton={!!searchValue}
          size="small"
          type="search"
          value={searchValue}
        />
      </div>
    )}
  </div>
);

ManageSearch.propTypes = {
  className: PropTypes.string,
  customFilterProps: PropTypes.shape({
    filterText: PropTypes.string,
    isFilterSet: PropTypes.bool,
    onClearButtonClick: PropTypes.func,
    onFilterButtonClick: PropTypes.func,
    onFilterTextClick: PropTypes.func,
  }),
  filtersCount: PropTypes.number,
  hasCustomFilterButton: PropTypes.bool,
  hasDisplayButton: PropTypes.bool,
  hasFilterButton: PropTypes.bool,
  hasSearch: PropTypes.bool,
  inputId: PropTypes.string,
  isCustomFilterDisabled: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isDisplayButtonDisabled: PropTypes.bool,
  isFilterButtonDisabled: PropTypes.bool,
  isSearchDisabled: PropTypes.bool,
  onDisplayButtonClick: PropTypes.func,
  onFilterButtonClick: PropTypes.func,
  onSearchChange: PropTypes.func,
  onSearchClick: PropTypes.func,
  onSearchFocus: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  searchValue: PropTypes.string,
};

export default ManageSearch;
